import { Dialog, DialogActions, DialogContent, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import EnhancedConfirmButton from "src/components/enhanced/EnhancedConfirmButton";
import EnhancedTextField from "src/components/enhanced/EnhancedTextField";
import { insertCompanySums } from "src/features/companySumSlice";
import { fetchAllowedCompanyList } from "src/features/listsSlice";
import EnhancedDialogTitle from "src/components/enhanced/EnhancedDialogTitle";
import alertHelper from "../../helpers/alertHelper";
import EnhancedDateField from "src/components/enhanced/EnhancedDateField";
import EnhancedSelect from "../enhanced/EnhancedSelect";

function NewCompanySumDialog(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { open, setOpenNew } = props;
  const [formState, setFormState] = useState({});

  const allowedCompanyList = useSelector((state) => state.lists.allowedCompanyList);

  useEffect(() => {
    open && dispatch(fetchAllowedCompanyList());
  }, [open, dispatch]);

  const handleChange = (event) => {
    event.persist();
    setFormState((formState) => ({
      ...formState,
      [event.target.name]: event.target.value
    }));
  };

  const handleClose = () => {
    setOpenNew(false);
    setFormState({});
  };

  const handleSave = () => {
    const apiData = {
      companyId: formState.companyId,
      validitySince: formState.validitySince,
      validityTo: formState.validityTo,
      sumUpSum: formState.sumUpSum,
      slevomatSum: formState.slevomatSum,
    };

    if (!formState.companyId) {
      alertHelper.error({ message: "Musíte zadat organizaci!" });
      return false;
    }

    if (!formState.validitySince || !formState.validityTo) {
      alertHelper.error({ message: "Musíte zadat datum platnosti od do!" });
      return false;
    }

    if (!formState.sumUpSum || !formState.slevomatSum) {
      alertHelper.error({ message: "Musíte zadat sumarizační hodnoty!" });
      return false;
    }

    dispatch(insertCompanySums(apiData))
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="md" aria-labelledby="form-dialog-title">
        <EnhancedDialogTitle handleClose={handleClose} nameLabel="Vložit sumarizační hodnoty za organizaci" />
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <EnhancedSelect
                  name="companyId"
                  value={formState.companyId}
                  label="Organizace"
                  list={allowedCompanyList}
                  itemId="companyId"
                  itemName="companyName"
                  onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <EnhancedDateField
                  name="validitySince"
                  value={formState.validitySince}
                  label="Platnost od"
                  onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <EnhancedDateField
                  name="validityTo"
                  value={formState.validityTo}
                  label="Platnost do"
                  onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <EnhancedTextField
                  name="sumUpSum"
                  value={formState.sumUpSum}
                  label="SumUp hodnota"
                  onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <EnhancedTextField
                  name="slevomatSum"
                  value={formState.slevomatSum}
                  label="Počet uplatněných poukazů"
                  onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <EnhancedConfirmButton handleOk={handleSave} okLabel="Vložit" />
        </DialogActions>
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  }
}));

export default NewCompanySumDialog;
